export type Currency = 'USDT' | 'TON' | 'NOT' | 'BTC';

export enum CurrencyEnum {
  USDT = 'USDT',
  TON = 'TON',
  NOT = 'NOT',
  BTC = 'BTC',
}
